import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { ProForm } from '@ant-design/pro-components';
import _ from 'lodash';
import React from 'react';
import { ProFormSelectButtonOperator } from "./Operator";
export var ProFormSelectButton = function ProFormSelectButton(properties) {
  var fieldNames = _objectSpread({
    id: 'id',
    description: 'description',
    name: 'name'
  }, properties.fieldNames);
  var _transform = function transform(entity) {
    if (entity) {
      return _defineProperty({}, fieldNames.id, _.get(entity, fieldNames.id));
    } else {
      return null;
    }
  };
  return /*#__PURE__*/React.createElement(ProForm.Item, _extends({
    transform: function transform(value, namePath) {
      if (value) {
        // 记录数据
        var transformedValue;
        // 处理数据
        if (_.isPlainObject(value)) {
          var _properties$fieldProp;
          if ((_properties$fieldProp = properties.fieldProps) !== null && _properties$fieldProp !== void 0 && _properties$fieldProp.mode) {
            // 单选数据 要 多选结果 | ?
            transformedValue = [_transform(value)];
          } else {
            // 单选数据 要 单选结果
            transformedValue = _transform(value);
          }
        } else if (_.isArray(value)) {
          var _properties$fieldProp2;
          if ((_properties$fieldProp2 = properties.fieldProps) !== null && _properties$fieldProp2 !== void 0 && _properties$fieldProp2.mode) {
            // 多选数据 要 多选结果
            transformedValue = value.map(_transform);
          } else {
            // 多选数据 要 单选结果 | ?
            transformedValue = _transform(value[0]);
          }
        } else {
          // 不做处理, 因为我也不知道传进来了什么玩意
          transformedValue = value;
        }
        // 返回数据
        return _defineProperty({}, namePath, transformedValue);
      } else {
        return {};
      }
    },
    getValueProps: function getValueProps(value) {
      return {
        value: _.isPlainObject(value) ? [value] : value
      };
    }
  }, _.omit(properties, ['entityTransformer'])), /*#__PURE__*/React.createElement(ProFormSelectButtonOperator, _extends({}, properties, {
    fieldNames: fieldNames
  })));
};